import { ReloadOutlined } from "@ant-design/icons";
import { notification, Select } from "antd";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";

import ChartsContainer from "./ChartsContainer";
const ChartSummaryMetrics = (props) => {
  const { getGraphData, region, channelId, sourceArn, timeStamp, streamStartTime, streamEndTime } = props;
  const [disabled, setDisabled] = useState(false);
  const [statistics, setStatistics] = useState("Average");
  const [graphData, setGraphData] = useState({});
  const [initialLoad, setInitialLoad] = useState(parseInt(timeStamp) ? true : false);
  const timeStampDiff = useMemo(() => {
    if (timeStamp) return moment().unix() - timeStamp;
  }, [timeStamp]);
  const [timeStampDiffHour] = useState(timeStampDiff / 3600);
  const [period, setPeriod] = useState(timeStamp ? (timeStampDiffHour < 1 ? 30 : 60) : 300);
  const [timePeriod, setTimePeriod] = useState(
    timeStamp
      ? timeStampDiffHour < 1
        ? 1
        : timeStampDiffHour < 3
          ? 3
          : timeStampDiffHour < 8
            ? 8
            : timeStampDiffHour < 12
              ? 12
              : timeStampDiffHour < 24
                ? 24
                : timeStampDiffHour < 72
                  ? 72
                  : timeStampDiffHour < 168
                    ? 168
                    : 168
      : 1,
  );
  const customParams = useMemo(() => {
    return {
      timePeriod,
      period,
      statistics,
      region,
      channelId,
    };
  }, [timePeriod, period, statistics, region, channelId]);

  // fetch graph data in channel summary page, based on changes in custom params

  const fetchGraphData = _.debounce(async () => {
    setDisabled(true);
    if (channelId.length) {
      try {
        const timeParams =
          timePeriod > 168
            ? {
                streamEndTime: streamEndTime ? parseInt(streamEndTime) : moment().unix(),
                streamStartTime: Math.max(parseInt(streamStartTime), moment().unix() - customParams.timePeriod * 3600),
              }
            : { time_period: timePeriod * 3600 };
        const payload = {
          region: customParams.region,
          channelId: customParams.channelId,
          Period: customParams.period,
          Statistics: customParams.statistics,
          source_arn: sourceArn,
          ...timeParams,
        };

        const graphData = await getGraphData(payload);
        setGraphData(graphData.value);
      } catch (error) {
        notification["error"]({ message: "Something went wrong" });
        console.error("Health metrics API error:", {
          error: error.message,
          channelId,
          region,
        });
      }
    }
    setDisabled(false);
  }, 500);
  useEffect(() => {
    fetchGraphData();
  }, [customParams]);

  const handleRefresh = async () => {
    setInitialLoad(false);
    await fetchGraphData();
  };

  const handleStatisticsChange = (value) => {
    setInitialLoad(false);
    setStatistics(value);
  };
  const handlePeriodChange = (value) => {
    setInitialLoad(false);
    setPeriod(value);
  };
  const handleClick = (event) => {
    setInitialLoad(false);
    setTimePeriod(parseInt(event.target.value));
  };

  return (
    <React.Fragment>
      <div className="container-fluid pt-3">
        <div className="gap-3 d-flex align-content-center justify-content-end">
          <div className="time-select-container-btn" onClick={handleClick}>
            <button className={timePeriod === 1 ? "active" : ""} value={1} disabled={disabled}>
              1h
            </button>
            <button className={timePeriod === 3 ? "active" : ""} value={3} disabled={disabled}>
              3h
            </button>
            <button className={timePeriod === 8 ? "active" : ""} value={8} disabled={disabled}>
              8h
            </button>
            <button className={timePeriod === 12 ? "active" : ""} value={12} disabled={disabled}>
              12h
            </button>
            <button className={timePeriod === 24 ? "active" : ""} value={24} disabled={disabled}>
              1d
            </button>
            <button className={timePeriod === 72 ? "active" : ""} value={72} disabled={disabled}>
              3d
            </button>
            <button className={timePeriod === 168 ? "active" : ""} value={168} disabled={disabled}>
              1w
            </button>
            <button
              className={timePeriod > 168 ? "active" : ""}
              value={Math.max(169, moment().unix() - streamStartTime + 1800)}
              disabled={disabled}
            >
              All
            </button>
          </div>
          <Select
            className="custom-date-picker"
            disabled={disabled}
            defaultValue={statistics}
            style={{ minWidth: 200 }}
            onChange={handleStatisticsChange}
            options={[
              { value: "Average", label: "Average" },
              { value: "Minimum", label: "Minimum" },
              { value: "Maximum", label: "Maximum" },
              { value: "Sum", label: "Sum" },
              { value: "SampleCount", label: "Sample Count" },
            ]}
          />

          <Select
            className="custom-date-picker"
            disabled={disabled}
            value={period}
            style={{ minWidth: 200 }}
            onChange={handlePeriodChange}
            options={[
              { value: 1, label: "1 sec" },
              { value: 5, label: "5 sec" },
              { value: 10, label: "10 sec" },
              { value: 30, label: "30 sec" },
              { value: 60, label: "1 min" },
              { value: 300, label: "5 min" },
              { value: 900, label: "15 min" },
              { value: 3600, label: "1 hour" },
              { value: 21600, label: "6 hour" },
              { value: 86400, label: "1 day" },
            ]}
          />

          <button className="btn btn-primary" onClick={handleRefresh} disabled={disabled}>
            <ReloadOutlined className="btn-icon-left" />
            Refresh
          </button>
        </div>
      </div>

      <ChartsContainer
        graphData={graphData}
        timePeriod={timePeriod}
        channelId={channelId}
        isSrt={sourceArn !== ""}
        initialLoad={initialLoad}
        timeStamp={timeStamp}
      />
    </React.Fragment>
  );
};
export default ChartSummaryMetrics;
